import _str from "shared/util/_str";

const FOOTER_LINK = {
	Apps: {
		name: _str("Apps"),
		href: "/mobile",
	},
	Press: {
		name: _str("Press"),
		href: "/press",
	},
	AdChoices: {
		name: _str("Ad Choices"),
		href: "/legal/privacy#third-parties",
	},
	About: {
		name: _str("About"),
		href: "/about",
	},
	Careers: {
		name: _str("Careers"),
		href: "/careers",
	},
	Support: {
		name: _str("Support"),
		href: "https://help.okcupid.com",
	},
	Blog: {
		name: _str("Blog"),
		href: "https://theblog.okcupid.com",
	},
	TechBlog: {
		name: _str("Tech Blog"),
		href: "https://tech.okcupid.com",
	},
	Privacy: {
		name: _str("Privacy Policy"),
		href: "/legal/privacy",
	},
	Cookies: {
		name: _str("Cookie Policy"),
		href: "/legal/cookies",
	},
	Terms: {
		name: _str("Terms & Conditions"),
		href: "/legal/terms",
	},
	Safety: {
		name: _str("Dating Safety Tips"),
		href: "/legal/safety-tips",
	},
	CommunityGuidelines: {
		name: _str("Community Guidelines"),
		href: "https://help.okcupid.com/article/142-community-guidelines",
	},
	Security: {
		name: _str("Security"),
		href: "/security",
	},
};

export default FOOTER_LINK;



// WEBPACK FOOTER //
// ./src/shared/constants/footerLink.js